<template>
  <div class="edit">
    <div class="warp">
      <span @click="close" class="close">
        <Icon type="md-close"/>
      </span>
      <div class="contain_main">
          <makeissue
            v-if="editshow"
            :order="'ID:'+message.questionid"
            @exit="exit"
            @complated="edit"
            :message="message"
          />
      </div>
    </div>
  </div>
</template>
<script>
import makeissue from "../../components/makeissue";
import { Question_getInfo } from "../../assets/js/api.js";
export default {
  name: "issuedit",
  data() {
    return {
      message: {
        questioncreatetime: "", //	number	true	创建时间
        questionlevel: "", //	number	true	难度1简单2中等3困难
        questionscore: "", //	number	true	分值
        questiondescribe: "", //	string	true	知识点
        questionselect: "", //	object	true	选项
        qttitle: "", //	string	true	题型
        qbtitle: "", //	string	true	分类
        question: "", //	string	true	试题
        questionusername: "", //	string	true	出卷人
        questionpoint:"",
        questionid: "" //	number	true	试题id
      },
      editshow:false
    };
  },
  props: ["questionid"],
  beforeMount() {
    if (this.questionid) {
      this.getmessage(this.questionid);
    }
  },
  components: {
    makeissue
  },
  methods: {
    getmessage(data) {
      Question_getInfo({ questionid: data }).then(res => {
        if (res.data.code == 200) {
          res.data.data.isedit = true 
          this.message = res.data.data;
          console.log(this.message)
          this.editshow = true
        }
      });
    },
    close() {
      this.$emit("close");
    },
    edit() {
      this.$emit("success");
    },
    exit() {
      this.close();
    }
  }
};
</script>
<style lang="css" scoped>
.edit {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(250, 250, 250, 0.7);
}
.warp {
  padding: 20px;
  width: 1000px;
  background: #fff;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 0 20px 0 #bbb;
}
.contain_main {
  width: 100%;
  overflow-y:auto;
}
.close {
  font-size: 25px;
  position: absolute;
  top: -5px;
  right: 0px;
  color: #999;
}
</style>


// WEBPACK FOOTER //
// src/pages/issue/issuedit.vue